import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api.service';
import { NotifyService } from 'src/app/services/notify.service';
import { ValueService } from 'src/app/services/value.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-approval-modal',
  templateUrl: './approval-modal.component.html',
  styleUrls: ['./approval-modal.component.css'],
})
export class ApprovalModalComponent implements OnInit {
  private ApprovalApi = environment.url + environment.preincubaterapproval;
  /**
   * Construct a new ApprovalModalComponent.
   * @param data - The data that has been passed from the parent component.
   * @param makeapi - The API service.
   * @param getdata - The value service.
   * @param notify - The notification service.
   * @param dialogRef - The dialog reference.
   */
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private makeapi: ApiService,
    private getdata: ValueService,
    private notify: NotifyService,
    public dialogRef: MatDialogRef<ApprovalModalComponent>
  ) {
    /**
     * The data that has been passed from the parent component.
     */
    this.datas = data;
    /**
     * The id of the pre-incubator that needs to be approved or rejected.
     */
    this.reasondata = this.datas._id;
  }
  reasondata;
  ngOnInit(): void {}

  preIncubatorId = sessionStorage.getItem('userId');
  datas;

  /**
   * Sends a request to the server to approve or reject the pre-incubator
   * with the given status.
   */
  approval() {
    const req = {
      /**
       * The id of the user who is performing the action.
       */
      userId: this.preIncubatorId,
      /**
       * The status to update the pre-incubator to.
       */
      status: this.reasondata,
    };

    this.makeapi.method(this.ApprovalApi, req, 'post').subscribe((data) => {
      this.getdata.amizhthLoader('hide');
      if (data.responseStatus === 'Success') {
        /**
         * If the request was successful, notify the user of success.
         */
        this.notify.notifysuccess(data.responseMessage);
        /**
         * Close the dialog.
         */
        this.dialogRef.close();
      }
    });
  }
  /**
   * Closes the dialog and doesn't perform any action.
   * This is typically used when the user clicks the cancel button.
   */
  cancelReason() {
    this.dialogRef.close();
  }
}
